"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePlaybackHistoryItems = exports.setPlaybackHistoryMetadata = exports.addHistory = void 0;
var initialState = {
    items: [],
    metadata: {},
};
function addHistory(item, maxSize) {
    return {
        type: "playbackHistory/add",
        payload: {
            item: item,
            maxSize: maxSize,
        },
    };
}
exports.addHistory = addHistory;
function setPlaybackHistoryMetadata(metadata) {
    return {
        type: "playbackHistory/setMetadata",
        payload: {
            metadata: metadata,
        },
    };
}
exports.setPlaybackHistoryMetadata = setPlaybackHistoryMetadata;
function removePlaybackHistoryItems(onAirs) {
    return {
        type: "playbackHistory/removeItems",
        payload: {
            onAirs: onAirs,
        },
    };
}
exports.removePlaybackHistoryItems = removePlaybackHistoryItems;
function playbackHistoryReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case "playbackHistory/add":
            return {
                items: __spreadArray(__spreadArray([], __read(state.items), false), [
                    __assign({}, action.payload.item),
                ], false).slice(-action.payload.maxSize),
                metadata: state.metadata,
            };
        case "playbackHistory/setMetadata":
            return __assign(__assign({}, state), { metadata: __assign(__assign({}, (state.metadata || {})), action.payload.metadata) });
        case "playbackHistory/removeItems":
            return {
                items: __spreadArray([], __read(state.items.filter(function (item) {
                    return !action.payload.onAirs.includes(item.onAir);
                })), false),
                metadata: {
                    isSending: false,
                    lastSend: Date.now(),
                    lastSuccess: Date.now(),
                },
            };
        default:
            return state;
    }
}
exports.default = playbackHistoryReducer;
//# sourceMappingURL=playbackHistory.js.map